import CityPageTemplate from "../city-template/CityPageTemplate";
import { wheelingConfig } from "./data";

export default function WheelingPage() {
  return <CityPageTemplate config={wheelingConfig} />;
}